module.controller('giftVirtualRegister', ['$scope', '$state', '$sce', 'baseURI', '$http', 'Transform', '$stateParams', '$window', '$timeout', 'giftAuthService', 'trustPilotService', 'brandService', function($scope, $state, $sce, baseURI, $http, Transform, $stateParams, $window, $timeout, giftAuthService, trustPilotService, brandService){
  var giftVirtualRegisterUrl = baseURI + 'gift-card/collect/virtual';
  var vm = this;
  $scope.passwordInputType = 'password';
  $scope.showValidateEmail = false;
  $scope.showUpdatedEmail = false;
  $scope.loadingEmailVerification = false;
  $scope.attemptToChangeEmail = false;
  $scope.canChangeEmail = false;
  $scope.collectEmailLabel = "New Email";
  $scope.bypassEmailVerification = false;

  // lets set the email or phone number
  var emailOrPhone = $stateParams.email;
  if (emailOrPhone.includes('@')) {
    if (!$scope.formData.email) {
      $scope.formData.email = emailOrPhone;
    }
  }
  else {
    if (!$scope.formData.phone) {
      $scope.formData.phone = emailOrPhone.replace(/[\(\)\.\-\ ]/g, '');
    }
    $scope.canChangeEmail = true;
    $scope.collectEmailLabel = "Email";
    $scope.bypassEmailVerification = true;
  }

  // set parent view form class
  $scope.parent.formType = 'floatingForm-form';

  var goToSuccessPage = function(message) {
    $state.go('root.redeem.success', {
      successMessage: message,
      username: $scope.formData.email,
    });
  };

  $scope.attemptSubmission = function(joinForm){
    if(joinForm.$valid){
      verifyEmail();
    } else {
      $scope.submitted = true;
    }
  };

  vm.submitRegistration = function(){
    $scope.parent.overlayLoading = true;
    var formData = $scope.formData;

    var request = {
      FirstName: formData.firstName,
      LastName: formData.lastName,
      Username: $scope.formData.email,
      Email: $scope.formData.email,
      NewEmail: $scope.formData.updatedEmail || '',
      Phone: formData.phone,
      Password: formData.password
    };

    $http({
      method: 'POST',
      url: giftVirtualRegisterUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function (resp){
      var data = resp.data;

      $scope.parent.overlayLoading = false;
      data.email = request.Email;

      if($scope.formData.textAlerts){
        // set txt alerts for primary
        // if sub, set the subcard username
        data.textAlerts = {
          phoneNumber: $scope.formData.phone,
          subcard: null
        };
      } else {
        data.textAlerts = false;
      }
      if(typeof data.Data.OAuthData === "undefined" || data.Data.OAuthData === null) {
        var successMessage = "We found an existing account for you and have applied these funds to that account. Please log in to your existing account to see these funds.";
        goToSuccessPage(successMessage);
      } else {
        // Scroll to top
        $window.scrollTo(0,0);
        giftAuthService.handleAuth(data, $scope.formData.VerificationCode);
        trustPilotService.sendTpInvitation(request.Email, request.FirstName, 'giftVirtual');
      }
    }).catch(function(err){
      $scope.parent.overlayLoading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Oops, we are unable to register your card at this time.';
    });
  };

  $scope.changeEmail =function(){
    $scope.attemptToChangeEmail = true;
    verifyEmail();
  };

  $scope.updatePhone = function() {
    // $scope.formData.Phone = $scope.formData.Phone1 + $scope.formData.Phone2 + $scope.formData.Phone3;
  };

  // Verification email process
  var verifyEmail = function(){
    if($scope.bypassEmailVerification) {
      /*
      $scope.$parent.verifiedEmail = true;
      $scope.loadingEmailVerification = true;
      $scope.showValidateEmail = false;
      submitRegistration();
      */
      $scope.formData.email = $scope.formData.updatedEmail;
      // successVerfication();

      $scope.formData.verificationMethod = 'phone';
    } else {
      // createVerificationCode();
      // selectVerificationMethod();
      $scope.formData.verificationMethod = 'email';
    }

    $scope.verificationMethodIsPhone = $scope.formData.verificationMethod === 'phone';
    $scope.verificationMethodIsEmail = $scope.formData.verificationMethod === 'email';

    createVerificationCode();
  };

  // Make request for validation Code
  var createVerificationCode = function(){
    $scope.loading = true;

    var reqData = {
      VerificationType: $scope.formData.verificationMethod,
      Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : $scope.formData.email,
      _key: $scope.brand.api_key
    };

    var errorFn = function(errorCode) {
      switch(errorCode){
        case 31:
          $scope.alertError.cardNotFoundLinkLogin = true;
          break;

        default:
          $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
      $scope.loading = false;
      $scope.alertError.show = true;
    };

    $http.get(giftVirtualRegisterUrl + '?Email=' +  encodeURIComponent($scope.formData.email) + '&Phone=' + $scope.formData.phone)
      .then(function(resp){
        $http({
          url: baseURI + 'member/verification',
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
          data: Transform.encode(reqData)
        }).then(function(resp){
          $scope.loading = false;
          if(resp.data.Success){
            // Open the modal
            $scope.showValidateEmail = true;
            startCountDown();
          } else {
            errorFn(resp.data.ErrorCode);
          }
        }).catch(function(error){
          errorFn(error.data.ErrorCode);
        });
      }).catch(function(error){
        errorFn(error.data.ErrorCode);
      });
  };

  // User is manually submitting code
  $scope.submitCode = function(){
    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        VerificationType: $scope.formData.verificationMethod,
        Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : $scope.formData.email,
        VerificationCode: $scope.formData.VerificationCode
      };

      $http({
        url: baseURI + 'member/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  // Close the modal
  $scope.close = function(){
    if ($scope.showSelectVerificationMethod) {
      $scope.showSelectVerificationMethod = false;
    }
    else {
      $scope.stopTimeout();
      $scope.showValidateEmail = false;
    }
  };

  // User has successfully completed email verification
  var successVerfication = function(){
    $scope.$parent.verifiedEmail = true;
    $scope.loadingEmailVerification = true;
    $scope.showValidateEmail = false;

    if($scope.attemptToChangeEmail){
      $scope.canChangeEmail = true;
      $scope.attemptToChangeEmail = false;
    } else {
      $state.go('root.collect.virtual.esignDisclosure');
    }
  };

  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };
  };

  //Agreements

  vm.section1 = true;
  vm.section2 = false;
  vm.section3 = false;
  vm.section4 = false;

  vm.eSignAgreed = false;
  vm.disclosureAgreed = false;
  vm.privacyAgreed = false;
  vm.feesScheduleAgreed = false;

  $scope.eSignErrorMessage = 'Please check this box if you agree to the E-sign disclosure. You must agree to the E-sign disclosure to continue.';
  $scope.cardholderAgreementErrorMessage = 'Please check this box if you agree to the Cardholder Agreement. You must agree to the Cardholder Agreement to continue.';
  $scope.privacyPolicyErrorMessage = 'Please check this box if you agree to the Sunrise Banks Privacy Policy. You must agree to the Sunrise Banks Privacy Policy to continue.';

  var urlRoot = window.location.href.split('#')[0];
  var currentBrand = $scope.brand.name;
  var brand = brandService.getBrand($stateParams.brand);

  function resolvePdfUrl(basePath, fallbackPath, callback) {
    $http.head(basePath).then(
        function () {
          callback(basePath);
        },
        function () {
          callback(fallbackPath);
        }
    );
  }

  function initializePdfSources() {
    var defaultAgreement = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2021/07/Cardholder-Agreement_GPR_Akimbo_FICENTIVEAKIMBOMCGPRTC_0721-8.pdf';
    var currentBrandAgreement = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/cardholder-agreement.pdf';

    resolvePdfUrl(
        currentBrandAgreement,
        defaultAgreement,
        function (resolvedUrl) {
          vm.pdfGDSrcAgreement = resolvedUrl + '#toolbar=0';
          vm.pdfGDSrcAgreementDownload = resolvedUrl;
        }
    );

    var defaultFeeSchedule = urlRoot.replace('?', '') + 'assets/pdf/akimbo/fee-schedule.pdf';
    var currentBrandFeeSchedule = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf';

    resolvePdfUrl(
        currentBrandFeeSchedule,
        defaultFeeSchedule,
        function (resolvedUrl) {
          vm.feesSchedule = resolvedUrl + '#toolbar=0';
          vm.feesScheduleDownload = resolvedUrl;
        }
    );

    vm.pdfGDSrcDisclosure = brand.programLegal.disclosure + '#toolbar=0';
    vm.pdfGDSrcDisclosureDownload = brand.programLegal.disclosure;

    vm.pdfGDSrcPrivacy = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2020/03/Sunrise-Banks-Privacy-Notice-Safe-Harbor.pdf#toolbar=0';
    vm.pdfGDSrcPrivacyDownload = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2020/03/Sunrise-Banks-Privacy-Notice-Safe-Harbor.pdf';

    vm.feesSchedule = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf#toolbar=0';
    vm.feesScheduleDownload = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf';
  }

  vm.trustSrc = function (src) {
    return $sce.trustAsResourceUrl(src);
  };

  vm.Finish = function (nextStep) {
    $state.go(nextStep, { joinType: $scope.joinType });
  };

  vm.downloadFile = function (url, filename) {
    var link = $window.document.createElement('a');
    link.href = url;
    link.download = filename;
    link.target = '_blank';
    $window.document.body.appendChild(link);
    link.click();
    $window.document.body.removeChild(link);
  };

  function initializeController() {
    initializePdfSources();
  }

  initializeController();
}]);
